import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function Divider(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_jsx("hr", {
    className: classNames('prezly-slate-divider', className)
  });
}